module.exports = __webpack_public_path__ + "img/Ninja Girl_1.jpg";